import { render } from "./ModalSearchPostalCode.vue?vue&type=template&id=209c3e7e&scoped=true"
import script from "./ModalSearchPostalCode.vue?vue&type=script&lang=js"
export * from "./ModalSearchPostalCode.vue?vue&type=script&lang=js"

import "../styles/ModalSearchPostalCode.scss?vue&type=style&index=0&id=209c3e7e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209c3e7e"]])

export default __exports__